import React, { Component } from 'react';
import TopPoster from './TopPoster';
import {
	Segment,
	Header,
	Accordion,
	Icon,
	Image,
	List,
} from 'semantic-ui-react';

class MetaPanel extends Component {
	state = {
		activeIndex: 0,
		privateChannel: this.props.isPrivateChannel,
		channel: this.props.currentChannel,
	};

	setActiveIndex = (event, titleProps) => {
		const { index } = titleProps;
		const { activeIndex } = this.state;
		const newIndex = activeIndex === index ? -1 : index;
		this.setState({
			activeIndex: newIndex,
		});
	};

	createPoster = (arr, i) => {
		console.log('iam called');
		return <TopPoster arr={arr} i={i} />;
	};

	displayTopPosters = () => {
		var elements = Object.entries(this.props.userPosts).sort(
			(a, b) => b[1] - a[1]
		);

		elements.forEach((arr, i) => this.createPoster(arr, i));
	};
	render() {
		const { activeIndex, privateChannel, channel } = this.state;
		const { userPosts } = this.props;
		if (privateChannel) return null;
		return (
			<Segment loading={!channel}>
				<Header as='h1' attached='top'>
					About # {channel && channel.name}
				</Header>
				<Accordion styled attached='true'>
					<Accordion.Title
						active={activeIndex === 0}
						index={0}
						onClick={this.setActiveIndex}
					>
						<Icon name='dropdown' />
						<Icon name='info' />
						Channel Details
					</Accordion.Title>
					<Accordion.Content active={activeIndex === 0}>
						{channel && channel.details}
					</Accordion.Content>

					<Accordion.Title
						active={activeIndex === 1}
						index={1}
						onClick={this.setActiveIndex}
					>
						<Icon name='dropdown' />
						<Icon name='user circle' />
						Top Posters
					</Accordion.Title>
					<Accordion.Content active={activeIndex === 1}>
						{userPosts && this.displayTopPosters()}
					</Accordion.Content>

					<Accordion.Title
						active={activeIndex === 2}
						index={2}
						onClick={this.setActiveIndex}
					>
						<Icon name='dropdown' />
						<Icon name='pencil alternate' />
						Created By
					</Accordion.Title>
					<Accordion.Content active={activeIndex === 2}>
						<Header as='h3'>
							<Image circular src={channel && channel.createdBy.avatar} />
							{channel && channel.createdBy.name}
						</Header>
						<List>{userPosts && this.displayTopPosters}</List>
					</Accordion.Content>
				</Accordion>
			</Segment>
		);
	}
}

export default MetaPanel;



// WEBPACK FOOTER //
// ./src/components/MetaPanel/MetaPanel.js